import ApiService from '@/services/api';
import { EntityBuilder } from '@decahedron/entity';
import Picture from '@/entities/Picture';

let instance: PictureService = null;

export default class PictureService {
  apiService: ApiService = null;

  constructor() {
    if (!instance) {
      this.apiService = new ApiService();
      instance = this;
    }

    return instance;
  }

  upload(picture: File, type: string) {
    const data = new FormData();
    data.append('picture', picture);
    data.append('type', type);
    return this.apiService.post('pictures', data)
      .then((response) => EntityBuilder.buildOne(Picture, response.data));
  }

  uploadData(data: string, fielname: string, type: string) {
      return this.resizeImage(data)
        .then((resizedPictureData: string) => this.urltoFile(resizedPictureData, fielname)
            .then((resizedPicture: File) => this.upload(resizedPicture, type)));
  }

  protected resizeImage(data: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      const img = document.createElement('img');
      img.src = data;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      setTimeout(() => {
        const MAX_WIDTH = 2000;
        const MAX_HEIGHT = 2000;
        let width = img.width; // eslint-disable-line
        let height = img.height; // eslint-disable-line

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }

        canvas.width = width;
        canvas.height = height;
        const resizedCanvas = canvas.getContext('2d');
        resizedCanvas.drawImage(img, 0, 0, width, height);

        resolve(canvas.toDataURL('image/jpeg', 100));
      }, 200);
    });
  }

  protected dataURLtoFile(dataurl: string, filename: string) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n) {
      u8arr[n] = bstr.charCodeAt(n);
      n -= 1;
    }

    return new File([u8arr], filename, { type: mime });
  }

  protected urltoFile(url: string, filename: string, mimeType: string = null) {
    const mime = mimeType || url.split(',')[0].match(/:(.*?);/)[1];

    return fetch(url)
      .then((res) => res.arrayBuffer())
      .then((buf) => new File([buf], filename, { type: mime }));
  }
}
